import { ConnectionManager } from 'spacetimedb';

/**
 * Compute the same pool key the SDK uses internally.
 *
 * `DbConnectionBuilder.withUri(uri)` stores `new URL(uri)`, so the URI the
 * SDK retains is normalized (trailing slash, lowercased host, etc.). If we
 * call `ConnectionManager.rebuild(key, ...)` with a raw `https://...cloud`
 * but the entry was retained under `https://...cloud/`, rebuild returns
 * null — every reconnect path silently fails and only a page reload
 * recovers. Normalize the URI exactly as the builder would.
 */
export function getPoolKey(uri: string, moduleName: string): string {
  let normalized = uri;
  try {
    normalized = new URL(uri).toString();
  } catch {
    // Unparseable — the builder's `new URL(uri)` would throw too, so
    // falling back to the raw string keeps us consistent with whatever
    // the builder does (likely also failing).
  }
  return ConnectionManager.getKey(normalized, moduleName);
}
